export default __webpack_public_path__ + "static/media/errorIconEmpty.2335d789.svg";